<template>
    <div id="portfolio" class="section">
        <span v-if="language==='EN'">
            <PageTitle :title="'Portfolio'" :subtitle="subtitle_EN" :description="description_EN" /><br>
                <v-card>
                    <v-card-title>
                        <p class="title">
                            You are cordially invited to view my portfolio!
                        </p>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex xs12 sm4>
                                <a class="banner andron" href="http://www.hlynskyi.com.ua" target="_blank">&nbsp;</a>
                            </v-flex>
                            <v-flex sx12 sm8 pl-3 pb-2>
                                <p>My Favorite photographer is Andriy Hlinskiy. He is the author of most of my photos. He is the ultimate professional in his field, creative with every motion and frame.</p>
                                <p>For more details: <a href="http://hlynskyi.com.ua" target="_blank">www.hlynskyi.com.ua</a></p>
                            </v-flex>
                        </v-layout>

                    <!-- <hr>

                    <v-layout row wrap>
                        <v-flex sx12 sm8>
                            <p>Wardrobe from a young, talented, award winning designer, Natalia Palii. Natalia, fashion designer, is the founder of the project "Select your own designer" and fashion club "My Line". Every piece she creates is a beautiful work of art. </p>
                            <p>For more details: <a href="https://myline.com.ua/" target="_blank">www.myline.com.ua</a></p>
                        </v-flex>                        
                        <v-flex xs12 sm4 pl-3 pb-2>
                            <a class="banner andron" href="https://myline.com.ua/" target="_blank">&nbsp;</a>
                        </v-flex>
                    </v-layout> -->
                </v-card-text>
            </v-card>
        </span>
        <span v-if="language==='RU'">
            <PageTitle :title="'Портфолио'" :subtitle="subtitle_RU" :description="description_RU" /><br>
             <v-card>
                    <v-card-title>
                        <p class="title">
                            You are cordially invited to view my portfolio!
                        </p>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex xs12 sm4>
                                <a class="banner andron" href="http://www.hlynskyi.com.ua" target="_blank">&nbsp;</a>
                            </v-flex>
                            <v-flex sx12 sm8 pl-3 pb-2>
                                <p>My Favorite photographer is Andriy Hlinskiy. He is the author of most of my photos. He is the ultimate professional in his field, creative with every motion and frame.</p>
                                <p>For more details: <a href="http://hlynskyi.com.ua" target="_blank">www.hlynskyi.com.ua</a></p>
                            </v-flex>
                        </v-layout>

                <!--<hr>
                   <v-layout row wrap>
                        <v-flex sx12 sm8>
                            <p>Wardrobe from a young, talented, award winning designer, Natalia Palii. Natalia, fashion designer, is the founder of the project "Select your own designer" and fashion club "My Line". Every piece she creates is a beautiful work of art. </p>
                            <p>For more details: <a href="https://myline.com.ua/" target="_blank">www.myline.com.ua</a></p>
                        </v-flex>                        
                        <v-flex xs12 sm4 pl-3 pb-2>
                            <a class="banner andron" href="https://myline.com.ua/" target="_blank">&nbsp;</a>
                        </v-flex>
                    </v-layout> -->
                </v-card-text>
            </v-card>
        </span>
        <span v-if="language==='UA'">
            <PageTitle :title="'Портфоліо'" :subtitle="subtitle_UA" :description="description_UA" /><br>
             <v-card>
                    <v-card-title>
                        <p class="title">
                            Запрошую Вас переглянути моє портфоліо!
                        </p>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex xs12 sm4>
                                <a class="banner andron" href="http://www.hlynskyi.com.ua" target="_blank">&nbsp;</a>
                            </v-flex>
                            <v-flex sx12 sm8 pl-3 pb-2>
                                <p>Один з найулюбленіших мною фотографів – Андрій Глинський, автор практично усіх моїх фото. Він спражній митець, великий майстер своєї справи, творчий підхід в кожному подиху...</p>
                                <p>Детальніше:: <a href="http://hlynskyi.com.ua" target="_blank">www.hlynskyi.com.ua</a></p>
                            </v-flex>
                        </v-layout>

                <!--<hr>
                    <v-layout row wrap>
                        <v-flex sx12 sm8>
                            <p>Сукні від молодого дизайнера, переможниці багатьох міжнородних конкурсів Наталії Палій. Наталія - модельєр та засновник проекту "Обери свого дизайнера!" і Клубу моди "Моя ЛІНіЯ". Кожна її річ неповторна.</p>
                            <p>Детальніше: <a href="https://myline.com.ua/" target="_blank">www.myline.com.ua</a></p>
                        </v-flex>                        
                        <v-flex xs12 sm4 pl-3 pb-2>
                            <a class="banner liniya" href="https://myline.com.ua/" target="_blank">&nbsp;</a>
                        </v-flex>
                    </v-layout> -->
                </v-card-text>
            </v-card>
        </span>

        <ImageShooter :directory="'portfolio'" :quantity="30" />
        <v-btn class="success" block to="/gallery">MORE PHOTOS IN GALLERY</v-btn>      
    </div>
</template>

<script>
    import PageTitle from '@/components/PageTitle'
    import ImageShooter from '@/components/ImageShooter'
    import { MyFunctions } from '@/data/functions.js'

    export default {
    name: 'Portfolio',
        components: { PageTitle, ImageShooter },
        data: () => ({
           language: '',

           subtitle_EN: 'CREATIVE PHOTO SESSIONS AND PARTNERS',
           subtitle_RU: 'ТВОРЧЕСКАЯ ФОТОСЕССИЯ И ПАРТНЕРЫ',           
           subtitle_UA: 'ТВОРЧА СЕСІЯ І ПАРТНЕРИ',

           description_EN: '',
           description_RU: '',
           description_UA: ''                      
        }),
        mounted(){ 
            this.language = MyFunctions.getLanguage()  
        } 
    }
</script>

<style>
    .andron {
        margin-top: 10px;
        background-image: url('/img/banners-sprite.png');
        background-position: 0px -173px;
        background-repeat: no-repeat;
        float: left;
    }
    .andron:hover {
        background-position: 0px -262px;  
    }
    .liniya {
        margin-top: 30px;
        background-image: url('/img/banners-sprite.png');
        background-position: 0px 0px;
        background-repeat: no-repeat;
        float: right;
    }
    .liniya:hover {
        background-position: 0px -85px;         
    }
    .banner {
        width: 100%;
        height: 84px;
        border-radius: 5px;
    }
</style>
